export const StorePerson = {
    state: {
        me: "person.me",
        token: "person.token",
    },
    set: "person/set",
    login: "person/login",
    logout: "person/logout",
    get: "person/get",
    getToken: "person/getToken",
    isLogin: "person/isLogin",
    isLoginWait: "person/isLoginWait",
};

export const StoreNotification = {
    state: {
        list: "notification.list",
    },
    setListItem: "notification/setListItem",
    setList: "notification/setList",
    getEndSendDateUnReaded: "notification/getEndSendDateUnReaded",
    getEndSendDate: "notification/getEndSendDate",
    getCountUnReaded: "notification/getCountUnReaded",
    getCountReaded: "notification/getCountReaded",
    getListUnReaded: "notification/getListUnReaded",
    getListAll: "notification/getListAll",
};